var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkDarkActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25910",
    d: "M4.5 3.5C4.5 2.94771 4.94772 2.5 5.5 2.5H18.5C19.0523 2.5 19.5 2.94772 19.5 3.5V20.5737C19.5 20.9714 19.0581 21.2099 18.7256 20.9917L12.5487 16.9371C12.2156 16.7184 11.7844 16.7184 11.4513 16.9371L5.27438 20.9917C4.94188 21.2099 4.5 20.9714 4.5 20.5737V3.5Z",
    fill: "url(#paint0_linear_872_1278)",
    stroke: "currentColor",
    strokeWidth: 2.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_872_1278",
    x1: 6.10714,
    y1: 2.5,
    x2: 23.052,
    y2: 17.4828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#713D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3343"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkDarkActive);
export default __webpack_public_path__ + "static/media/bookmark-dark-active.3502d65c817814b34b083746edd80130.svg";
export { ForwardRef as ReactComponent };